import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { NoData } from "src/shared/components/tables/no-data";
import { TableLoadingSkeleton } from "src/shared/components/tables/table-loading-skeleton";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Link from "@mui/material/Link";
import { getJournalEntryRoute } from "../constants";

const GeneralLedgerTable = ({
  data,
  isFetching,
}: {
  data: any;
  isFetching: boolean;
}) => {
  const emptyDataArr = data?.length === 0;
  const { t } = useTranslation("purchasing");
  const { t: generalT } = useTranslation("general");

  const HeadText = [
    generalT("date"),
    t("journalId"),
    t("source"),
    generalT("reference"),
    generalT("account"),
    t("parentAccount"),
    generalT("description"),
    generalT("debit"),
    generalT("credit"),
    generalT("branch"),
    generalT("createdAt"),
    generalT("createdBy"),
  ];

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {HeadText.map((item) => (
              <TableCell
                key={item}
                align={"center"}
                sx={{
                  bgcolor: "#F9FAFB",
                }}
              >
                <Typography
                  fontSize={"12px"}
                  color={"#475467"}
                  lineHeight={"18px"}
                  fontWeight={500}
                >
                  {item}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        {isFetching ? (
          <TableLoadingSkeleton rowsLength={15} cellsLength={11} />
        ) : (
          <TableBody>
            {data?.map((row: any) => {
              return (
                <>
                  <TableRow
                    sx={{
                      "& td": {
                        borderTop: "1px solid #D0D5DD",
                        borderBottom: "none",
                        backgroundColor: "#F9FAFB",
                        fontWeight: 500,
                      },
                      "& td:first-of-type": {
                        borderTopLeftRadius: "10px",
                      },
                      "& td:last-of-type": {
                        borderTopRightRadius: "10px",
                      },
                    }}
                    key={row.id}
                  >
                    <TableCell align="center">{row.date}</TableCell>
                    <TableCell align="center">{row.reference}</TableCell>
                    <TableCell align="center">{row.source_text}</TableCell>
                    <TableCell align="center">
                      {row.related_reference && (
                        <Link
                          component={RouterLink}
                          to={getJournalEntryRoute(row)}
                          underline="always"
                          sx={{ fontSize: "inherit" }}
                        >
                          {row.related_reference}
                        </Link>
                      )}
                    </TableCell>
                    <TableCell align="center"></TableCell>
                    <TableCell align="center"></TableCell>
                    <TableCell align="center">{row.description}</TableCell>
                    <TableCell align="center">{}</TableCell>
                    <TableCell align="center">{}</TableCell>
                    <TableCell align="center">{row.branch}</TableCell>
                    <TableCell align="center">{row.created_at}</TableCell>
                    <TableCell align="center">{row.created_by?.name}</TableCell>
                  </TableRow>
                  {/* Items rows */}
                  {row.items?.map((item: any, index: number) => {
                    const isLast = index === row.items.length - 1;
                    return (
                      <TableRow
                        key={`${row.id}-${item.id}`}
                        sx={{
                          "& td": {
                            borderBottom: isLast ? "1px solid #D0D5DD" : "none",
                            backgroundColor: "#FFFFFF",
                          },
                          "& td:first-of-type": {
                            borderBottomLeftRadius: isLast ? "10px" : 0,
                          },
                          "& td:last-of-type": {
                            borderBottomRightRadius: isLast ? "10px" : 0,
                          },
                        }}
                      >
                        <TableCell colSpan={4} /> {/* empty spacing */}
                        <TableCell align="center">{item.account}</TableCell>
                        <TableCell align="center">
                          {item.parent_account}
                        </TableCell>
                        <TableCell align="center">{item.description}</TableCell>
                        <TableCell align="center">{item.debit}</TableCell>
                        <TableCell align="center">{item.credit}</TableCell>
                        <TableCell colSpan={2} />
                      </TableRow>
                    );
                  })}
                </>
              );
            })}
          </TableBody>
        )}
      </Table>
      {emptyDataArr && <NoData />}
    </TableContainer>
  );
};
export default GeneralLedgerTable;
